import { render, staticRenderFns } from "./CancelShipmentsButton.vue?vue&type=template&id=4dab9554"
import script from "./CancelShipmentsButton.vue?vue&type=script&lang=js"
export * from "./CancelShipmentsButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports